import { TelegramAccount } from '../../shared/types/TelegramAccount'
import { TelegramAccountEntity } from '../../domain/entities/TelegramAccount'

export type TelegramAccountAPIModel = TelegramAccount

export const mapApiToEntity = (api: TelegramAccountAPIModel): TelegramAccountEntity =>
  TelegramAccountEntity.create({ id: api.id, uuid: api.uuid, phone: api.phone, accountID: api.accountID, status: api.status as any })
